import { useState } from 'react';
import { useMessages } from '@scope/scope-one-ui/core';
import { useGetNavigatorAccess, useRequestNavigatorAccess } from 'services/navigator';

export const useNavigator = () => {
  const [isRequestPending, setRequestPending] = useState(false);
  const hasAccessToNavigatorApp = useGetNavigatorAccess();
  const requestAccess = useRequestNavigatorAccess();
  const { success } = useMessages();

  const requestAccessToNavigator = () => {
    setRequestPending(true);
    requestAccess()
      .then(() => success({ title: 'Success', content: 'Request for access sent!' }))
      .finally(() => setRequestPending(false));
  };

  return {
    hasAccessToNavigatorApp,
    requestAccessToNavigator,
    isRequestPending,
  };
};
